/* eslint-disable complexity */
// 9fbef606107a605d69c0edbcd8029e5d
/** @module ProductRating
 */

import React, { useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import {
  isBVWebEnabled,
  isPixleeWebEnabled,
  isPixleeCustomWARWebEnabled,
  getIsStyleColorRnREnabled,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import { getIconPath, getViewportInfo, isClient, getAPIConfig } from '@tcp/core/src/utils';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import errorBoundary from '@tcp/core/src/components/common/hoc/withErrorBoundary/errorBoundary';
import SocialProofMessage from '@tcp/core/src/components/features/browse/ProductDetail/molecules/SocialProofMessage/container/SocialProofMessage.container';
import injectWriteReviewReducer from '@tcp/core/src/components/features/browse/WriteReviewDetail/container/WriteReviewDynamicStore';
import { getLabelFromCopyOrFromTranslation } from '@tcp/core/src/utils/labels/labelUtilty';
import { PDP_SUB_LABELS, pdpSubLabels } from '@tcp/core/src/utils/labels/browse/PDP.labels';
import ProductRatingStyle, {
  CustomRankingContainer,
  ProductRatingWrapper,
  RankingWrapper,
  RatingsContainer,
  RatingStarGrey,
  RatingStarOverlay,
  RatingStarYellow,
  ReviewsCount,
  ReviewsCountRedesign,
  SocialProofMessageWrapper,
} from './styles/ProductRating.style';
import withStyles from '../../../../../common/hoc/withStyles';
import Image from '../../../../../common/atoms/Image';

const getNewYPosition = (ratingReviewSection, isNewPJPPDPRedesignEnabled, isMobile) => {
  let yPos = ratingReviewSection && ratingReviewSection.getBoundingClientRect().top;
  if (ratingReviewSection) {
    if (isNewPJPPDPRedesignEnabled) yPos += isMobile ? window.scrollY - 20 : window.scrollY - 250;
    else yPos += isMobile ? window.scrollY - 5 : window.scrollY - 70;
  }
  return yPos;
};
const executeScroll = (
  pageName,
  handleRatingClick,
  isNewPJPPDPRedesignEnabled,
  setPdpTabSectionName
) => {
  const isMobile = isClient() ? getViewportInfo()?.isMobile : null;
  let ratingReviewSection = document.querySelector('.bv-content-list-container')
    ? document.querySelector('.ratings-and-reviews-accordion')
    : null;
  if (!ratingReviewSection) {
    ratingReviewSection = document.querySelector('.reviews-anchoring-wrapper')
      ? document.querySelector('.reviews-anchoring-wrapper')
      : null;
  }
  const yPos = getNewYPosition(ratingReviewSection, isNewPJPPDPRedesignEnabled, isMobile);
  if (yPos && pageName === 'PDP') {
    handleRatingClick(true);
    window.scrollTo({
      top: yPos,
      behavior: 'smooth',
    });
    if (isNewPJPPDPRedesignEnabled) {
      setPdpTabSectionName('reviews');
    }
  }
  ratingReviewSection = null;
};

const combinedAB = (isTileRedesignAB, isRatingRedesignAbTest) =>
  isTileRedesignAB || isRatingRedesignAbTest;

const handleReviewLinkClick = async (e, customFormEnabled, widgetType, linkClickHandler) => {
  if (widgetType === 'Pixlee') {
    if (customFormEnabled) {
      await injectWriteReviewReducer();
      linkClickHandler(e);
    } else {
      window.TurnToCmd('reviewsList.writeReview');
    }
  } else if (widgetType === 'BV') {
    await injectWriteReviewReducer();
    linkClickHandler(e);
  }
};

const renderCustomRatings = ({
  ratings,
  reviews,
  className,
  pageName,
  socialProofMessage,
  isNewQVEnabled,
  isNewPDPEnabled,
  handleRatingClick,
  ratingsProductId,
  isGiftCard,
  setProductDataForReviewActn,
  primaryBrand,
  productName,
  colorDisplayId,
  isBagPage,
  starRatingSize,
  isNewPJPPDPRedesignEnabled,
  setPdpTabSectionName,
  isConfirmationPage,
  isTileRedesignAB,
  isRatingRedesignAbTest,
  isBVWidget,
  isPixleeWidget,
  isPixleeCustomWARFormEnabled,
  isPDPRedesignEnabled,
  favoritedCount,
  handleAddRemoveFromWishlistObj,
  outFitFavt,
  stickyAtbHeader,
  isStyleColorRnREnabled,
  // eslint-disable-next-line sonarjs/cognitive-complexity
}) => {
  const writeAReviewLabel = getLabelFromCopyOrFromTranslation(
    `${PDP_SUB_LABELS}.lbl_write_review`,
    pdpSubLabels
  );
  const beTheFirstToReviewLbl = getLabelFromCopyOrFromTranslation(
    `${PDP_SUB_LABELS}.lbl_be_first_to_review`,
    pdpSubLabels
  );
  const starsRatingWhite = getIconPath('stars-rating');
  const tab = isNewPDPEnabled ? 1 : -1;
  const { isMobile } = isClient() && getViewportInfo();
  const onLinkClick = (e) => {
    e.preventDefault();
    setProductDataForReviewActn({
      isWriteReviewModalOpen: true,
      productDataForReview: { primaryBrand, productName, colorDisplayId, ratingsProductId },
    });
  };

  const executeScrollClickHandler = () => {
    executeScroll(pageName, handleRatingClick, isNewPJPPDPRedesignEnabled, setPdpTabSectionName);
  };

  useEffect(() => {
    if (isPixleeWidget && !isPixleeCustomWARFormEnabled && ratingsProductId) {
      const { PIXLEE_SITE_KEY, locale = 'en_US' } = getAPIConfig();
      const initializePixleeConfig = () => {
        window.turnToConfig = {
          locale,
          pageId: 'pdp-page',
          sku: isStyleColorRnREnabled ? ratingsProductId : ratingsProductId?.split('_')[0],
        };
        window.TurnToCmd =
          window.TurnToCmd ||
          // eslint-disable-next-line func-names
          function () {
            // eslint-disable-next-line prefer-rest-params
            (window.TurnToCmd.q = window.TurnToCmd.q || []).push(arguments);
          };
      };
      if (window.turnToConfig) {
        window.TurnToCmd('set', {
          sku: isStyleColorRnREnabled ? ratingsProductId : ratingsProductId?.split('_')[0],
        });
        initializePixleeConfig();
      } else {
        initializePixleeConfig();
        const script = document.createElement('script');
        script.src = `https://widgets.turnto.com/v5/widgets/${PIXLEE_SITE_KEY}/js/turnto.js`;
        script.async = true;
        document.body.appendChild(script);
        const popoverStyle = document.createElement('style');
        popoverStyle.textContent = `.tt-o-popover--success {
          background-color: #fff !important;
        }
        .tt-o-popover--success p.tt-o-popover__text {
          color: #008477 !important;
        }
        .tt-o-popover--success .tt-o-icon {
          fill: #008477 !important;
        }
        `;
        document.head.appendChild(popoverStyle);
      }
    }
  }, [isPixleeWidget, isPixleeCustomWARFormEnabled, ratingsProductId]);
  return (
    <RankingWrapper
      className={`ranking-wrapper ${className}`}
      isNewPJPPDPRedesignEnabled={isNewPJPPDPRedesignEnabled}
      pageName={pageName}
      isPDPRedesignEnabled={isPDPRedesignEnabled && pageName === 'PDP'}
    >
      <RatingsContainer
        className="ratings-container"
        isNewPJPPDPRedesignEnabled={isNewPJPPDPRedesignEnabled}
        pageName={pageName}
        isTileRedesignAB={isTileRedesignAB}
        isRatingRedesignAbTest={isRatingRedesignAbTest}
        isPDPRedesignEnabled={isPDPRedesignEnabled && pageName === 'PDP'}
      >
        {Number(ratings) >= 0 && (
          <CustomRankingContainer
            isBagPage={isBagPage}
            className="custom-ranking-container"
            isNewPJPPDPRedesignEnabled={isNewPJPPDPRedesignEnabled}
            pageName={pageName}
            isConfirmationPage={isConfirmationPage}
            isTileRedesignAB={isTileRedesignAB}
            isRatingRedesignAbTest={isRatingRedesignAbTest}
          >
            <RatingStarOverlay
              pageName={pageName}
              starRatingSize={starRatingSize}
              className="rating-star-overlay"
              ratings={ratings}
              isTileRedesignAB={isTileRedesignAB}
              isRatingRedesignAbTest={isRatingRedesignAbTest}
              isPDPRedesignEnabled={isPDPRedesignEnabled && pageName === 'PDP'}
            >
              <RatingStarYellow
                aria-hidden={true}
                src={starsRatingWhite}
                title={`Product ratings - ${ratings}`}
                alt="Star Rating Icon"
                className="rating-star-yellow"
                onClick={executeScrollClickHandler}
                onKeyPress={executeScrollClickHandler}
                role="button"
                tabIndex={tab}
                isNewPDPEnabled={isNewPDPEnabled}
                isNewPJPPDPRedesignEnabled={isNewPJPPDPRedesignEnabled}
                isTileRedesignAB={isTileRedesignAB}
                isRatingRedesignAbTest={isRatingRedesignAbTest}
                isPDPRedesignEnabled={isPDPRedesignEnabled && pageName === 'PDP'}
                stickyAtbHeader={stickyAtbHeader}
              />
            </RatingStarOverlay>
            <RatingStarGrey
              src={starsRatingWhite}
              title="Product ratings"
              alt="Star Rating Icon"
              className={`${
                combinedAB(isTileRedesignAB, isRatingRedesignAbTest) ? '' : 'rating-star-grey'
              }`}
              ratings={ratings}
              onClick={executeScrollClickHandler}
              onKeyPress={executeScrollClickHandler}
              role="button"
              tabIndex={tab}
              pageName={pageName}
              isTileRedesignAB={isTileRedesignAB}
              isRatingRedesignAbTest={isRatingRedesignAbTest}
            />
            {Number(reviews) >= 0 && Number(ratings) >= 0 && !isNewQVEnabled && !isNewPDPEnabled && (
              <ReviewsCount
                component="span"
                fontFamily="secondary"
                className={`${
                  combinedAB(isTileRedesignAB, isRatingRedesignAbTest) ? '' : 'reviews-count'
                }`}
                onClick={executeScrollClickHandler}
                onKeyPress={executeScrollClickHandler}
                role="button"
                tabIndex={tab}
                pageName={pageName}
                isNewPJPPDPRedesignEnabled={isNewPJPPDPRedesignEnabled}
                isTileRedesignAB={isTileRedesignAB}
                isRatingRedesignAbTest={isRatingRedesignAbTest}
              >
                {combinedAB(isTileRedesignAB, isRatingRedesignAbTest)
                  ? Number(reviews)
                  : `(${Number(reviews)})`}
              </ReviewsCount>
            )}
            {!!reviews && ratings && (isNewQVEnabled || isNewPDPEnabled) && (
              <ReviewsCountRedesign
                component="span"
                fontFamily="secondary"
                className={`${
                  combinedAB(isTileRedesignAB, isRatingRedesignAbTest)
                    ? ''
                    : 'reviews-count-quick-view-drawer-redesign'
                }`}
                onClick={executeScrollClickHandler}
                onKeyPress={executeScrollClickHandler}
                role="button"
                tabIndex={tab}
                pageName={pageName}
                isNewPDPEnabled={isNewPDPEnabled}
                isNewPJPPDPRedesignEnabled={isNewPJPPDPRedesignEnabled}
                isPDPRedesignEnabled={isPDPRedesignEnabled && pageName === 'PDP'}
              >
                {`${reviews}`}
              </ReviewsCountRedesign>
            )}
          </CustomRankingContainer>
        )}
      </RatingsContainer>

      {pageName === 'PDP' &&
        isPDPRedesignEnabled &&
        Number(ratings) === 0 &&
        isNewPDPEnabled &&
        (!isMobile || isNewPJPPDPRedesignEnabled) &&
        !isGiftCard && (
          <BodyCopy
            className="newwrite-review-link-redesign"
            fontFamily="secondary"
            fontSize="fs12"
            component="span"
            role="button"
            aria-label="Be the first one to review (opens pop-up)"
            onClick={(e) =>
              handleReviewLinkClick(
                e,
                isPixleeCustomWARFormEnabled,
                isPixleeWidget ? 'Pixlee' : 'BV',
                onLinkClick
              )
            }
            tabIndex={0}
          >
            {beTheFirstToReviewLbl}
          </BodyCopy>
        )}
      {/* Showing custom rating using above function and hiding rating from below div via css */}
      {pageName === 'PDP' &&
        !isPDPRedesignEnabled &&
        isNewPDPEnabled &&
        (!isMobile || isNewPJPPDPRedesignEnabled) &&
        !isGiftCard && (
          <BodyCopy
            className="newwrite-review-link"
            fontFamily="secondary"
            fontSize="fs12"
            component="span"
            role="button"
            aria-label="Write a Review (opens pop-up)"
            onClick={async (e) => {
              if (isPixleeWidget) {
                if (isPixleeCustomWARFormEnabled) {
                  await injectWriteReviewReducer();
                  onLinkClick(e);
                } else {
                  window.TurnToCmd('reviewsList.writeReview');
                }
              } else if (isBVWidget) {
                await injectWriteReviewReducer();
                onLinkClick(e);
              }
            }}
            tabIndex={0}
          >
            {writeAReviewLabel}
          </BodyCopy>
        )}

      {pageName === 'PDP' && isPDPRedesignEnabled && (
        <div className="fav-count">
          <div className="fav-count-bar" aria-hidden="true">
            |{' '}
          </div>
          <div
            className={'fav-heart-wrapper'}
            onClick={
              outFitFavt
                ? () =>
                    requestAnimationFrame(handleAddRemoveFromWishlistObj?.handleRemoveFromWishList)
                : () => requestAnimationFrame(handleAddRemoveFromWishlistObj?.handleAddToWishlist)
            }
            onKeyDown={
              outFitFavt
                ? (event) => {
                    if (event.key === 'Enter') {
                      requestAnimationFrame(
                        handleAddRemoveFromWishlistObj?.handleRemoveFromWishList
                      );
                    }
                  }
                : (event) => {
                    if (event.key === 'Enter') {
                      requestAnimationFrame(handleAddRemoveFromWishlistObj?.handleAddToWishlist);
                    }
                  }
            }
            role="button"
            tabIndex={0}
          >
            <Image src={getIconPath('fav-heart')} alt="Favorite Heart Icon" />
            <div className="fav-count-num" aria-label="Number of Favorites">
              {favoritedCount || 0}
            </div>
          </div>
        </div>
      )}
      {!isNewPJPPDPRedesignEnabled &&
        pageName === 'PDP' &&
        socialProofMessage?.variation === 'top' && (
          <SocialProofMessage socialProofMessage={socialProofMessage} />
        )}
    </RankingWrapper>
  );
};

const ProductRating = (props) => {
  const {
    className,
    isNewPDPEnabled,
    pageName,
    isNewPJPPDPRedesignEnabled,
    socialProofMessage,
    isTileRedesignAB,
    isRatingRedesignAbTest,
    isPDPRedesignEnabled,
  } = props;
  if (isPDPRedesignEnabled) {
    return (
      <>
        <ProductRatingWrapper
          className={`${className} ${isNewPDPEnabled ? 'rating-wrapper-new-pdp-redesign' : ''}`}
          isNewPJPPDPRedesignEnabled={isNewPJPPDPRedesignEnabled}
          pageName={pageName}
          isTileRedesignAB={isTileRedesignAB}
          isRatingRedesignAbTest={isRatingRedesignAbTest}
        >
          {renderCustomRatings(props)}
        </ProductRatingWrapper>
        {isNewPJPPDPRedesignEnabled &&
          pageName === 'PDP' &&
          socialProofMessage?.variation === 'top' && (
            <SocialProofMessageWrapper
              isNewPJPPDPRedesignEnabled={isNewPJPPDPRedesignEnabled}
              pageName={pageName}
            >
              <SocialProofMessage socialProofMessage={socialProofMessage} />
            </SocialProofMessageWrapper>
          )}
      </>
    );
  }

  return (
    <>
      <ProductRatingWrapper
        className={`${className} ${isNewPDPEnabled ? 'rating-wrapper-new-pdp' : ''}`}
        isNewPJPPDPRedesignEnabled={isNewPJPPDPRedesignEnabled}
        pageName={pageName}
        isTileRedesignAB={isTileRedesignAB}
        isRatingRedesignAbTest={isRatingRedesignAbTest}
      >
        {renderCustomRatings(props)}
      </ProductRatingWrapper>
      {isNewPJPPDPRedesignEnabled && pageName === 'PDP' && socialProofMessage?.variation === 'top' && (
        <SocialProofMessageWrapper
          isNewPJPPDPRedesignEnabled={isNewPJPPDPRedesignEnabled}
          pageName={pageName}
        >
          <SocialProofMessage socialProofMessage={socialProofMessage} />
        </SocialProofMessageWrapper>
      )}
    </>
  );
};

ProductRating.propTypes = {
  isNewPDPEnabled: PropTypes.bool,
  className: PropTypes.string,
  isNewPJPPDPRedesignEnabled: PropTypes.bool,
  pageName: PropTypes.string,
  setPdpTabSectionName: PropTypes.func,
};

ProductRating.defaultProps = {
  isNewPDPEnabled: false,
  className: '',
  isNewPJPPDPRedesignEnabled: false,
  pageName: '',
  setPdpTabSectionName: () => {},
};

const mapStateToProps = (state) => ({
  isPixleeWidget: isPixleeWebEnabled(state),
  isBVWidget: isBVWebEnabled(state),
  isPixleeCustomWARFormEnabled: isPixleeCustomWARWebEnabled(state),
  isStyleColorRnREnabled: getIsStyleColorRnREnabled(state),
});
const ProductRatingContainer = connect(mapStateToProps, null)(ProductRating);
export default errorBoundary(withStyles(ProductRatingContainer, ProductRatingStyle));
export { ProductRating as ProductRatingVanilla };
